// PeptideVault v6.5 — Calculator + templates

// ══════════════════════════════════════════════════════
// RENDER: RECONSTITUTION CALCULATOR
// ══════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════
// RENDER: TEMPLATES TAB — downloadable import templates
// ══════════════════════════════════════════════════════
function renderTemplatesTab() {
  const card = (title, desc, cols, importLocation, fnName) => `
    <div class="card" style="overflow:hidden">
      <div class="card-body" style="gap:10px">
        <div class="row" style="align-items:flex-start">
          <div style="flex:1">
            <div style="font-size:15px;font-weight:700">${esc(title)}</div>
            <div style="font-size:12px;color:var(--text3);margin-top:3px;line-height:1.4">${esc(desc)}</div>
          </div>
          <button class="btn btn-primary btn-sm" onclick="${fnName}()" style="flex-shrink:0">${ICONS.export} Download</button>
        </div>
        <div style="border-top:1px solid var(--border2);padding-top:8px">
          <div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px">Columns</div>
          <div style="display:flex;flex-wrap:wrap;gap:4px">
            ${cols.map(c => `<span style="font-size:11px;background:var(--bg3);border:1px solid var(--border);border-radius:4px;padding:2px 7px;font-family:var(--mono)">${esc(c)}</span>`).join('')}
          </div>
        </div>
        <div style="font-size:11px;color:var(--text4)">Import via <strong>${esc(importLocation)}</strong></div>
      </div>
    </div>`

  return `
  <div style="animation:fadeIn .25s ease">
    <div style="margin-bottom:20px">
      <h2 style="font-size:20px;font-weight:700">Import Templates</h2>
      <div style="font-size:13px;color:var(--text3);margin-top:4px;line-height:1.5;max-width:680px">
        Download a pre-formatted CSV with the exact column headers each importer expects. Fill in your data, keep the header row intact, and re-import from the listed location. This guarantees your columns map correctly and the data stays consistent.
      </div>
    </div>

    <div style="background:var(--blueL);border-radius:var(--r2);padding:12px 14px;margin-bottom:18px;font-size:12px;color:var(--text2);line-height:1.5">
      <strong>Tips for clean imports:</strong> Keep the first row (headers) exactly as provided · use <span style="font-family:var(--mono)">YYYY-MM-DD</span> for dates · match peptide and supplement names to what's already in your library when possible · leave a cell blank rather than guessing · save as CSV (UTF-8).
    </div>

    <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(320px,1fr));gap:14px">
      ${card(
        'Peptides',
        'Bulk-add peptides to your inventory with reference and stock details. One row per peptide; names matching existing peptides are skipped.',
        ['Name','Vial Name','Categories','Unit','Low Stock Threshold','Half-Life','Pep-Pedia URL','Notes'],
        'Peptides tab → Import CSV',
        'downloadPeptideTemplate'
      )}
      ${card(
        'Supplements',
        'Bulk-add or update supplements with dosing, timing, and reorder info. Names matching existing supplements will update them.',
        ['Name','Strength','Form','Brand','Category','Qty On Hand','Serving Size','Time of Day','Taken By','Expiry Date','Low Stock Alert','Reorder URL','Notes'],
        'Supplements tab → Import CSV',
        'downloadSuppTemplate'
      )}
      ${card(
        'Supply Locations',
        'Bulk-add supply locations (cabinet, drawer, shelf, etc.) with optional Total Capacity. Peptide locations are managed only by the B1/B2 vault map.',
        ['Name','Total Capacity'],
        'Locations tab → Import CSV',
        'downloadLocationTemplate'
      )}
      ${card(
        'Supply Location Inventory',
        'Place injection supplies into cabinet, drawer, or shelf locations. Existing supplies are matched by name and SKU barcode or lot.',
        ['Storage Location','Supply Name','SKU (barcode)','Quantity'],
        'Locations tab → Supply Locations → Import Supply Inventory',
        'downloadStorageInventoryTemplate'
      )}
      ${card(
        'Calendar (Injections)',
        'Bulk-import an injection schedule or log. Dates generate calendar entries; peptide names match your inventory where possible. The User column assigns each injection to a person (Todd, Meagan, etc.) — leave blank to default to the first user.',
        ['Date','Time','Peptide','Dosage','Draw Units','User','Notes'],
        'Calendar tab → Import CSV',
        'downloadInjectionTemplate'
      )}
    </div>
  </div>`
}

// ── Template download helpers ─────────────────────────
function downloadTemplateCSV(filename, headers, exampleRow) {
  const rows = [headers]
  if (exampleRow) rows.push(exampleRow)
  const csv = rows.map(r => r.map(c => '"' + String(c).replace(/"/g, '""') + '"').join(',')).join('\n')
  if (window.api) {
    window.api.showSaveDialog({ title:'Save Template', defaultPath:filename, filters:[{name:'CSV',extensions:['csv']}] })
      .then(p => { if (p) window.api.writeFile(p, csv).then(()=>showToast(filename + ' saved')) })
  } else {
    const blob = new Blob([csv], { type:'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url; a.download = filename; a.click()
    setTimeout(()=>URL.revokeObjectURL(url), 1000)
    showToast(filename + ' downloaded')
  }
}

function downloadInjectionTemplate() {
  const u1 = (S.users||[]).find(u=>u.active)?.name || 'Todd'
  const u2 = (S.users||[]).filter(u=>u.active)[1]?.name || 'Meagan'
  downloadTemplateCSV('Injections_Template.csv',
    ['Date','Time','Peptide','Dosage','Draw Units','User','Notes'],
    ['2026-07-01','AM','BPC-157','250mcg','25',u1,''])
}

function downloadLocationTemplate() {
  downloadTemplateCSV('Locations_Template.csv',
    ['Name','Total Capacity'],
    ['Refrigerator - Top Shelf','50'])
}

function downloadStorageInventoryTemplate() {
  downloadTemplateCSV('Supply_Location_Inventory_Template.csv',
    ['Storage Location','Supply Name','SKU (barcode)','Quantity'],
    ['Supply Cabinet - Drawer 1','Insulin Syringes','012345678905','25'])
}

function downloadPeptideTemplate() {
  downloadTemplateCSV('Peptides_Template.csv',
    ['Name','Vial Name','Categories','Unit','Low Stock Threshold','Half-Life','Pep-Pedia URL','Notes'],
    ['BPC-157','Healing Complex','Recovery / Tissue Repair','vials','2','4-6 hours','https://pep-pedia.org/bpc-157','Reconstitute with 2mL BAC water'])
}

function downloadSkuImportTemplate() {
  downloadTemplateCSV('Peptide_SKU_Import_Template.csv',
    ['Peptide','SKU Barcode','Vendor','Lot','Cap Color','Purity','Vial Strength','Vial Strength Unit','Tested Concentration','Expiry','Cost/Vial','Qty to Add','NIIMBOT Label','NIIMBOT QR'],
    ['DSIP','SAMLABS-yellow-100526',"Sam's Supplies",'SAMLABS-yellow-100526','Yellow','0.99','10','mg','11.21mg/vial','2027-06-30','45','5','⊙abc123⊙'])
}

function importSkuCSV() {
  const input = document.createElement('input')
  input.type = 'file'; input.accept = '.csv,.xlsx'
  input.onchange = async e => {
    const file = e.target.files[0]; if (!file) return
    showToast('Parsing SKU import…')
    try {
      let rows
      if (file.name.endsWith('.csv')) {
        const text = await file.text()
        rows = text.trim().split('\n').map(line => {
          const r = []; let cur = '', inQ = false
          for (let i = 0; i < line.length; i++) {
            const ch = line[i]
            if (ch === '"' && inQ && line[i+1] === '"') { cur += '"'; i++ }
            else if (ch === '"') inQ = !inQ
            else if (ch === ',' && !inQ) { r.push(cur.trim()); cur = '' }
            else cur += ch
          }
          r.push(cur.trim())
          return r
        })
      } else {
        const data = await file.arrayBuffer()
        rows = await parseXlsxNative(new Uint8Array(data))
      }
      processSkuImport(rows)
    } catch(err) {
      showToast('Failed: ' + err.message)
    }
  }
  input.click()
}

function processSkuImport(rows) {
  if (rows.length < 2) { showToast('No data rows found'); return }
  const header = rows[0].map(h => String(h||'').replace(/"/g,'').trim().toLowerCase())
  const col = name => header.findIndex(h => h.includes(name))

  const iPep = col('peptide')
  const iBarcode = col('barcode')
  const iVendor = col('vendor')
  const iLot = col('lot')
  const iCap = col('cap color')
  const iPurity = col('purity')
  const iStrength = col('vial strength')
  const iStrengthUnit = col('vial strength unit')
  const iConc = col('tested concentration') >= 0 ? col('tested concentration') : col('concentration')
  const iExpiry = col('expiry')
  const iCost = col('cost')
  const iQty = col('qty')
  const iNiimLabel = col('niimbot label')
  const iNiimQR = header.findIndex(h => h.includes('niimbot') && h.includes('qr'))

  if (iPep < 0) { showToast('CSV must have a "Peptide" column'); return }
  if (iQty < 0) { showToast('CSV must have a "Qty to Add" column'); return }

  function field(row, idx) {
    if (idx < 0 || !row[idx]) return ''
    return String(row[idx]).replace(/^"|"$/g, '').trim()
  }

  let added = 0, updated = 0, skipped = 0
  const results = []

  for (let i = 1; i < rows.length; i++) {
    const row = rows[i]
    const pepName = field(row, iPep)
    const qty = parseInt(field(row, iQty)) || 0
    if (!pepName || qty <= 0) { skipped++; continue }

    // Find matching peptide
    const peptide = S.peptides.find(p => p.name.toLowerCase() === pepName.toLowerCase())
    if (!peptide) { results.push(`⚠ "${pepName}" not found — skipped`); skipped++; continue }

    const barcode = field(row, iBarcode)
    const vendor = field(row, iVendor)
    const lot = field(row, iLot)

    // Try to match existing SKU by barcode or vendor+lot
    let sku = null
    if (barcode) sku = (peptide.skus||[]).find(s => s.barcode === barcode)
    if (!sku && vendor && lot) sku = (peptide.skus||[]).find(s => s.vendor === vendor && s.lotNumber === lot)
    if (!sku && lot) sku = (peptide.skus||[]).find(s => s.lotNumber === lot)

    if (sku) {
      // Existing SKU — add inventory
      var importedStrength = Number(field(row, iStrength)) || 0
      var importedTested = field(row, iConc)
      var importedStrengthUnit = normalizePlanningUnit(field(row, iStrengthUnit) || 'mg')
      if (importedStrength > 0) {
        sku.vialStrength = importedStrength
        sku.vialStrengthUnit = importedStrengthUnit
        sku.vialStrengthMg = importedStrengthUnit === 'mg' ? importedStrength : ''
      }
      if (importedTested) {
        sku.testedConcentration = importedTested
        sku.concentration = importedTested // legacy compatibility
      }
      if (!sku.transactions) sku.transactions = []
      sku.transactions.push({ id: 't_'+uid(), type: 'in', qty, date: new Date().toISOString(), notes: 'SKU import' })
      updated++
      results.push(`✓ ${pepName} / ${lot||barcode}: +${qty} (now ${skuQty(sku)})`)
    } else {
      // New SKU — create it
      if (!peptide.skus) peptide.skus = []
      const newSku = {
        id: 'sku_'+uid(),
        barcode: barcode,
        vendor: vendor,
        lotNumber: lot,
        capColor: field(row, iCap),
        purity: field(row, iPurity),
        vialStrength: Number(field(row, iStrength)) || '',
        vialStrengthUnit: normalizePlanningUnit(field(row, iStrengthUnit) || 'mg'),
        vialStrengthMg: normalizePlanningUnit(field(row, iStrengthUnit) || 'mg') === 'mg' ? (Number(field(row, iStrength)) || '') : '',
        testedConcentration: field(row, iConc),
        concentration: field(row, iConc),
        expiryDate: field(row, iExpiry),
        costPerVial: field(row, iCost),
        niimLabel: field(row, iNiimLabel),
        niimQR: field(row, iNiimQR),
        locations: [],
        transactions: [{ id: 't_'+uid(), type: 'in', qty, date: new Date().toISOString(), notes: 'SKU import' }],
        coaDocIds: []
      }
      peptide.skus.push(newSku)
      added++
      results.push(`+ ${pepName} / ${lot||barcode}: new SKU with ${qty} vials`)
    }
  }

  save(); render()
  const summary = `SKU Import: ${added} new, ${updated} updated, ${skipped} skipped`
  showToast(summary)
  if (results.length) {
    openModal('skuImportResults', { summary, results })
  }
}

function renderCalcTab() {
  // Inputs render once with initial values — calcUpdate() handles live recalc without re-rendering
  return `
  <div style="animation:fadeIn .25s ease;max-width:720px">
    <h2 style="font-size:20px;font-weight:700;margin-bottom:20px">Reconstitution Calculator</h2>

    <div class="calc-panel">
      <div style="font-size:13px;font-weight:700;color:var(--text2);text-transform:uppercase;letter-spacing:.5px;margin-bottom:14px">Inputs</div>
      <div class="form-row form-row-3" style="margin-bottom:12px">
        <div class="form-group">
          <label class="form-label">Vial Peptide (mg)</label>
          <input class="form-input" id="ci-vial" type="number" step="any" min="0" value="${S.calcVialMg}" oninput="calcUpdate()">
        </div>
        <div class="form-group">
          <label class="form-label">Bac Water (mL)</label>
          <input class="form-input" id="ci-water" type="number" step="any" min="0" value="${S.calcWaterMl}" oninput="calcUpdate()">
        </div>
        <div class="form-group">
          <label class="form-label">Syringe</label>
          <select class="form-input form-select" id="ci-syringe" onchange="S.calcSyringe=this.value;calcUpdate()">
            <option value="30u" ${S.calcSyringe==='30u'?'selected':''}>30 Unit</option>
            <option value="50u" ${S.calcSyringe==='50u'?'selected':''}>50 Unit</option>
            <option value="100u" ${S.calcSyringe==='100u'?'selected':''}>100 Unit</option>
          </select>
        </div>
      </div>
      <div class="form-row form-row-2">
        <div class="form-group">
          <label class="form-label">Desired Dose</label>
          <div class="row" style="gap:6px">
            <input class="form-input" id="ci-dose" type="number" step="any" min="0" value="${S.calcDoseMcg}" style="flex:1" oninput="calcUpdate()">
            <select class="form-input form-select" id="ci-unit" style="width:80px" onchange="S.calcDoseUnit=this.value;calcUpdate()">
              <option value="mcg" ${S.calcDoseUnit==='mcg'?'selected':''}>mcg</option>
              <option value="mg" ${S.calcDoseUnit==='mg'?'selected':''}>mg</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Concentration</label>
          <div class="form-input" id="ci-conc" style="background:var(--bg3);color:var(--text2)">—</div>
        </div>
      </div>
    </div>

    <!-- Result + syringe + table — updated in-place by calcUpdate() -->
    <div id="calc-output"></div>
  </div>`
}

// Called on every input event — updates only the output section, never re-renders inputs
function calcUpdate() {
  const vialMg  = parseFloat(document.getElementById('ci-vial')?.value)
  const waterMl = parseFloat(document.getElementById('ci-water')?.value)
  const doseVal = parseFloat(document.getElementById('ci-dose')?.value)
  const doseUnit = document.getElementById('ci-unit')?.value || S.calcDoseUnit
  const syringeKey = document.getElementById('ci-syringe')?.value || S.calcSyringe

  // Persist to state for tab switches
  if (!isNaN(vialMg))  S.calcVialMg  = vialMg
  if (!isNaN(waterMl)) S.calcWaterMl = waterMl
  if (!isNaN(doseVal)) S.calcDoseMcg = doseVal
  S.calcDoseUnit = doseUnit
  S.calcSyringe  = syringeKey

  const valid = vialMg > 0 && waterMl > 0 && doseVal > 0
  const concEl = document.getElementById('ci-conc')
  const outEl  = document.getElementById('calc-output')
  if (!outEl) return

  if (!valid) {
    if (concEl) concEl.textContent = '—'
    outEl.innerHTML = `<div class="card" style="padding:32px;text-align:center;color:var(--text3)">Enter values above to calculate</div>`
    return
  }

  const doseMcg     = doseUnit === 'mg' ? doseVal * 1000 : doseVal
  const syringeMax  = syringeKey === '30u' ? 30 : syringeKey === '50u' ? 50 : 100
  const concMgMl    = vialMg / waterMl
  const concMcgMl   = concMgMl * 1000
  const drawMl      = doseMcg / concMcgMl
  const drawUnits   = drawMl * 100          // actual fractional units
  const displayUnits = Math.ceil(drawUnits)  // rounded UP to next whole unit
  const clampedUnits = Math.min(displayUnits, syringeMax)
  const isOverflow   = drawUnits > syringeMax

  if (concEl) concEl.textContent = `${concMgMl.toFixed(3)} mg/mL = ${concMcgMl.toFixed(1)} mcg/mL`

  outEl.innerHTML = `
    <div class="calc-result-box" style="margin-bottom:16px">
      <div style="font-size:13px;opacity:.8;margin-bottom:4px">DRAW TO</div>
      <div style="font-size:44px;font-weight:800;line-height:1">${clampedUnits} <span style="font-size:20px;font-weight:400">units</span></div>
      <div style="font-size:14px;opacity:.7;margin-top:6px">(actual: ${drawUnits.toFixed(2)} units · ${drawMl.toFixed(3)} mL)</div>
      ${isOverflow ? `<div style="margin-top:10px;background:rgba(255,59,48,.3);border-radius:8px;padding:8px 14px;font-size:13px">⚠️ Exceeds ${syringeMax}-unit syringe. Use a larger syringe or split doses.</div>` : ''}
    </div>

    <div class="syringe-wrap">
      <div style="font-size:12px;font-weight:700;color:var(--text3);text-transform:uppercase;letter-spacing:.5px;margin-bottom:16px">${syringeMax}-Unit Insulin Syringe</div>
      ${renderSyringeSVG(clampedUnits, syringeMax)}
      <div class="syringe-zone-legend" style="margin-top:10px">
        <div class="row" style="gap:5px"><div class="syringe-zone-dot" style="background:rgba(52,199,89,.5)"></div><span style="font-size:11px;color:var(--text3)">Low (0–33%)</span></div>
        <div class="row" style="gap:5px"><div class="syringe-zone-dot" style="background:rgba(255,159,10,.5)"></div><span style="font-size:11px;color:var(--text3)">Mid (33–67%)</span></div>
        <div class="row" style="gap:5px"><div class="syringe-zone-dot" style="background:rgba(255,59,48,.45)"></div><span style="font-size:11px;color:var(--text3)">High (67–100%)</span></div>
        <div class="row" style="gap:5px"><div class="syringe-zone-dot" style="background:var(--blue)"></div><span style="font-size:11px;color:var(--text3)">Draw level</span></div>
      </div>
    </div>

    <div class="card" style="margin-top:16px">
      <div class="card-header"><div class="card-title">Summary</div></div>
      <table class="tbl">
        <tr><td style="color:var(--text3)">Vial peptide</td><td style="font-weight:600">${vialMg} mg</td></tr>
        <tr><td style="color:var(--text3)">Bacteriostatic water</td><td style="font-weight:600">${waterMl} mL</td></tr>
        <tr><td style="color:var(--text3)">Concentration</td><td style="font-weight:600">${concMcgMl.toFixed(1)} mcg/mL</td></tr>
        <tr><td style="color:var(--text3)">Desired dose</td><td style="font-weight:600">${doseVal} ${doseUnit}</td></tr>
        <tr><td style="color:var(--text3)">Volume to draw</td><td style="font-weight:600">${drawMl.toFixed(4)} mL</td></tr>
        <tr><td style="color:var(--text3)">Syringe (rounded up)</td><td style="font-weight:700;font-size:16px;color:var(--blue)">${clampedUnits} units</td></tr>
        <tr><td style="color:var(--text3)">Actual draw</td><td style="font-weight:600">${drawUnits.toFixed(2)} units</td></tr>
        <tr><td style="color:var(--text3)">Doses per vial</td><td style="font-weight:600">${doseMcg>0?(1000000*vialMg/doseMcg/1000).toFixed(1)+' doses':'—'}</td></tr>
      </table>
    </div>`
}


function renderSyringeSVG(drawUnits, maxUnits) {
  // Barrel shifted right to give room for long needle on left
  const bX = 128, bY = 30, bW = 388, bH = 48
  const midY = bY + bH / 2

  // Hub
  const hubL = bX - 22

  // Needle: shaft doubled from old version (~74px)
  const shaftEndX   = hubL
  const shaftStartX = hubL - 74
  const tipX        = shaftStartX - 14

  // Plunger right side
  const stopperX = bX + bW
  const rodEndX  = stopperX + 70
  const flangeX  = rodEndX

  // Dynamic viewBox to fit needle + plunger
  const vbLeft  = tipX - 8
  const vbWidth = flangeX + 20 - vbLeft
  const VH = 108

  // Color zones
  const z1 = bW * 0.333, z2 = bW * 0.333, z3 = bW * 0.334

  // Fill
  const fillPct = maxUnits > 0 ? Math.min(1, drawUnits / maxUnits) : 0
  const fillW   = fillPct * bW
  const drawX   = bX + fillW

  // Ticks
  const tickCount   = maxUnits === 30 ? 15 : 10
  const majorEvery  = maxUnits === 30 ? 3 : 2
  const tickSpacing = bW / tickCount
  let ticks = ''
  for (let i = 1; i <= tickCount; i++) {
    const x = bX + i * tickSpacing
    const isMajor = i % majorEvery === 0
    const h = isMajor ? 15 : 8
    const label = isMajor ? Math.round(i * maxUnits / tickCount) : null
    ticks += `<line x1="${x.toFixed(1)}" y1="${bY+bH}" x2="${x.toFixed(1)}" y2="${(bY+bH-h).toFixed(1)}" stroke="${isMajor?'#636366':'#c7c7cc'}" stroke-width="${isMajor?1.5:1}"/>`
    if (label !== null) ticks += `<text x="${x.toFixed(1)}" y="${(bY+bH+14).toFixed(1)}" text-anchor="middle" font-size="10" fill="#8e8e93" font-family="Inter">${label}</text>`
  }

  return `<div style="overflow:visible;-webkit-app-region:no-drag">
  <svg viewBox="${vbLeft} 0 ${vbWidth} ${VH}" width="100%" style="max-width:640px;display:block;margin:0 auto;overflow:visible">
    <defs>
      <linearGradient id="fluidGrad" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#5ac8fa"/>
        <stop offset="100%" stop-color="#0072B2"/>
      </linearGradient>
      <clipPath id="bClip">
        <rect x="${bX}" y="${bY}" width="${bW}" height="${bH}" rx="5"/>
      </clipPath>
    </defs>

    <!-- Color zone backgrounds -->
    <rect x="${bX}" y="${bY}" width="${z1.toFixed(1)}" height="${bH}" fill="rgba(52,199,89,0.09)" clip-path="url(#bClip)"/>
    <rect x="${(bX+z1).toFixed(1)}" y="${bY}" width="${z2.toFixed(1)}" height="${bH}" fill="rgba(255,159,10,0.09)" clip-path="url(#bClip)"/>
    <rect x="${(bX+z1+z2).toFixed(1)}" y="${bY}" width="${z3.toFixed(1)}" height="${bH}" fill="rgba(255,59,48,0.08)" clip-path="url(#bClip)"/>

    <!-- Barrel shell -->
    <rect x="${bX}" y="${bY}" width="${bW}" height="${bH}" rx="5" fill="rgba(255,255,255,0.95)" stroke="#d2d2d7" stroke-width="1.5"/>

    <!-- Fluid fill -->
    ${fillW > 1 ? `<rect x="${bX}" y="${bY}" width="${fillW.toFixed(1)}" height="${bH}" fill="url(#fluidGrad)" opacity="0.72" clip-path="url(#bClip)"/>` : ''}

    <!-- Glass highlight -->
    <rect x="${bX+2}" y="${bY+2}" width="${bW-4}" height="${bH/2-2}" rx="3" fill="rgba(255,255,255,0.4)" clip-path="url(#bClip)"/>

    <!-- Tick marks -->
    ${ticks}

    <!-- Draw indicator -->
    ${drawUnits > 0 ? `
    <line x1="${drawX.toFixed(1)}" y1="${(bY-4).toFixed(1)}" x2="${drawX.toFixed(1)}" y2="${(bY+bH+4).toFixed(1)}" stroke="#0072B2" stroke-width="2.5" stroke-dasharray="5,3"/>
    <polygon points="${drawX.toFixed(1)},${(bY-5).toFixed(1)} ${(drawX-7).toFixed(1)},${(bY-18).toFixed(1)} ${(drawX+7).toFixed(1)},${(bY-18).toFixed(1)}" fill="#0072B2"/>
    <rect x="${(drawX-26).toFixed(1)}" y="${(bY-36).toFixed(1)}" width="52" height="18" rx="5" fill="#0072B2"/>
    <text x="${drawX.toFixed(1)}" y="${(bY-24).toFixed(1)}" text-anchor="middle" font-size="11" fill="white" font-family="Inter" font-weight="700">${Math.ceil(drawUnits)}u</text>
    ` : ''}

    <!-- ═══ NEEDLE ═══ -->
    <!-- Luer hub collar (trapezoid: wide at barrel, narrow at shaft entry) -->
    <polygon points="${hubL},${(midY-5).toFixed(1)} ${hubL},${(midY+5).toFixed(1)} ${bX},${(bY+bH-8).toFixed(1)} ${bX},${(bY+8).toFixed(1)}"
             fill="#c8c8cc" stroke="#a1a1a6" stroke-width="1"/>

    <!-- Needle shaft — long thin stainless tube -->
    <rect x="${shaftStartX.toFixed(1)}" y="${(midY-2).toFixed(1)}" width="${(shaftEndX-shaftStartX).toFixed(1)}" height="4" rx="1" fill="#b0b0b6"/>
    <!-- Shaft highlight (glint along top edge) -->
    <rect x="${shaftStartX.toFixed(1)}" y="${(midY-2).toFixed(1)}" width="${(shaftEndX-shaftStartX).toFixed(1)}" height="1.5" rx="0.5" fill="rgba(255,255,255,0.6)"/>

    <!-- Beveled tip: sharp diagonal cut pointing left -->
    <polygon points="${tipX.toFixed(1)},${midY.toFixed(1)} ${shaftStartX.toFixed(1)},${(midY-2).toFixed(1)} ${shaftStartX.toFixed(1)},${(midY+2).toFixed(1)}"
             fill="#a8a8ae"/>
    <line x1="${shaftStartX.toFixed(1)}" y1="${(midY-2).toFixed(1)}" x2="${tipX.toFixed(1)}" y2="${midY.toFixed(1)}" stroke="rgba(255,255,255,0.45)" stroke-width="1"/>

    <!-- ═══ PLUNGER ═══ -->
    <!-- Rubber stopper -->
    <rect x="${stopperX.toFixed(1)}" y="${(bY+2).toFixed(1)}" width="9" height="${bH-4}" rx="3" fill="#636366" stroke="#555" stroke-width="0.5"/>

    <!-- Plunger rod -->
    <rect x="${(stopperX+9).toFixed(1)}" y="${(midY-3).toFixed(1)}" width="${(rodEndX-stopperX-9).toFixed(1)}" height="6" fill="#9a9a9e" rx="2"/>

    <!-- Plunger end cap — single solid vertical bar -->
    <rect x="${flangeX.toFixed(1)}" y="${(midY-20).toFixed(1)}" width="6" height="40" rx="3" fill="#8e8e93"/>

    <!-- Scale label -->
    <text x="${stopperX.toFixed(1)}" y="${(bY+bH+28).toFixed(1)}" text-anchor="end" font-size="10" fill="#8e8e93" font-family="Inter">${maxUnits} units → 1 mL</text>
  </svg>
  </div>`
}

export {
  renderTemplatesTab,
  downloadTemplateCSV,
  downloadInjectionTemplate,
  downloadLocationTemplate,
  downloadStorageInventoryTemplate,
  downloadPeptideTemplate,
  downloadSkuImportTemplate,
  importSkuCSV,
  processSkuImport,
  renderCalcTab,
  calcUpdate,
  renderSyringeSVG
}
